<div class="row" style="margin-top:100px;margin-left:10px;">
    <div class="col-lg-3"></div>
    <div class="col-lg-6" style="vertical-align:central;">
        <h3>You have been logged out from this Application</h3>
        <span style="text-decoration: underline"><a (click)="Login()">Please Click Here to Re-login</a> </span>
    </div>
    <div class="col-lg-3"></div>
</div>